import React, { useState, useEffect, useContext } from 'react';
import { EventContext } from '../CartContext';

const FlashModal = () => {
    const { settings } = useContext(EventContext);
    const [isOpen, setIsOpen] = useState(true); // Manage visibility internally
    const [settingsLoaded, setSettingsLoaded] = useState(false);
    const [settingImage, setSettingImage] = useState('');

    useEffect(() => {
        if (settings) {
            setSettingsLoaded(true);
            setSettingImage(`${process.env.REACT_APP_CDN_URL}/${settings?.EVENT_URL}/${settings?.SALE_CONTENT}`);
        }
    }, [settings]);

    const closeModal = () => {
        setIsOpen(false);
    };

    if (!isOpen || !settingsLoaded || settings?.ES_FLASH_SALE === 1) return null;

    return (
        <div style={modalOverlayStyle} onClick={closeModal}>
            <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
                {/* Close Button (Now Clickable) */}
                <button style={closeButtonStyle} onClick={closeModal}>&times;</button>

                {/* Image */}
                <div style={{backgroundColor:'transparent'}}>
                    <img style={popupModal} src={settingImage} alt="Flash Sale" />
                </div>
            </div>
        </div>
    );
};

// Styles
const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
};

const modalContentStyle = {
    position: 'relative',
    background: 'none',
    padding: '0px',
    borderRadius: '8px',
    textAlign: 'center',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
};

// Ensure close button is clickable
const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '15px',
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#666',
};

const popupModal = {
    borderRadius: '20px',
    padding: '0px',
    width: '275px'
}
export default FlashModal;
